import { render, staticRenderFns } from "./LabelList.html?vue&type=template&id=b288820e&scoped=true&"
import script from "./LabelList.js?vue&type=script&lang=js&"
export * from "./LabelList.js?vue&type=script&lang=js&"
import style0 from "./LabelList.scss?vue&type=style&index=0&id=b288820e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b288820e",
  null
  
)

export default component.exports